import ErrorContent from "../components/ErrorContent"

function Error404() {
    return (
        <main>
            <ErrorContent/>
        </main>
    )
}

export default Error404